import { Component } from '@angular/core';

import { NavController, Platform } from '@ionic/angular';
import { StatusBar, Style } from '@capacitor/status-bar';

import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FirebaseService } from './services/firebase.service';
import { TranslateConfigService } from './services/translate-config.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { SplashScreen } from '@capacitor/splash-screen';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { Events } from './services/events.service';
import { VersionService } from './services/version.service';
import { PaymentService } from './services/payment.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  user: any;
  public isAuthenticated = false;
  default_page = 'tab1';
  uuid: any = 'undefined';
  notifications_subscribed = false;
  app_status = "live";
  badge = 0;
  fcm: any;

  constructor(
    private platform: Platform,
    private authService: AuthService,
    private router: Router,
    private firebaseService: FirebaseService,
    private navCtrl: NavController,
    private device: Device,
    private events: Events,
    private translate: TranslateService,
    private translateConfigService: TranslateConfigService,
    private versionService: VersionService,
    private paymentService: PaymentService,
    public afAuth: AngularFireAuth
  ) {
    this.initializeApp();
    const url = this.router.url;

    console.log("url", url);
    console.log("window.location.href", window.location.href);
  }

  async initializeApp() {
    console.log("initializeApp");
    // this.translate.setDefaultLang('fr');
    // this.translate.use('fr');

    this.platform.ready().then(async () => {

      // let lang = await this.translateConfigService.initLang();
      // // console.log("lang",lang);
      // this.translateConfigService.setLanguage(lang);
      console.log("platform ready")
      // window["$crisp"].push(['do', 'chat:hide']);

      // this.keyboard.hideFormAccessoryBar(true);
      this.platform.backButton.subscribe(() => {
        // code that is executed when the user pressed the back button
      });
      // this.statusBar.styleDefault();
      if (this.platform.is("capacitor")) {
        SplashScreen.hide();
        StatusBar.setStyle({ style: Style.Light });
        if (this.platform.is("android")) {
          StatusBar.setBackgroundColor({ color: '#FFFFFF' })
        };
        StatusBar.setOverlaysWebView({ overlay: false });

        this.uuid = this.device.uuid ? this.device.uuid : 'undefined';
        console.log("uniqueDeviceID get", this.uuid);
      }

      this.afAuth.user.subscribe(async user => {
        // console.log("afAuth user subscribe", user)
        if (user) {
          this.navCtrl.navigateRoot("/tabs/" + this.default_page);

          console.log("this.afAuth.user.subscribe user ok", user);
          this.authService.setLoggedIn(true);
          await this.authService.setUser(user.uid);
          // this.router.navigate(["/tabs/" + this.default_page]);
          this.isAuthenticated = true;
          // this.registerToken('toto');
          // this.menu.enable(true);
        } else {
          console.log("this.afAuth.user.subscribe user null", user);
          this.checkCredentials()
        }
      }, err => {
        this.checkCredentials()
        console.log("this.afAuth.user.subscribe user err", err);
      }, () => {

      })

      this.events.subscribe('app_component', (data) => {
        console.log("data", data);
        if (data.notifications)
          this.subscribeNotifications();
      });
    });


    this.versionService.remoteConfigInit();
  }



  async checkCredentials() {
    let credentials = await this.authService.getCredentials();
    console.log("checkCredentials", credentials);
    if (credentials != null) {
      let user_exist = await this.firebaseService.getUserByEmail(credentials);
      console.log("checkCredentials user_exist", user_exist)
      if (user_exist.length == 0) {
        // this.router.navigate(["/login"]);
        this.navCtrl.navigateRoot('/login');
      }
      else {
        await this.authService.setUser(credentials);
        // this.router.navigate(["/tabs/" + this.default_page]);
        this.navCtrl.navigateRoot("/tabs/" + this.default_page);
      }
    }
    else {
      this.authService.setLoggedIn(false);
      await this.authService.setUser(null);
      // this.router.navigate(["/onboarding"]);
      this.navCtrl.navigateRoot('/onboarding');
      this.isAuthenticated = false;

    }
  }




  async subscribeNotifications() {
    if (!this.platform.is('capacitor')) {
      return;
    }
    console.log("subscribeNotifications")
    PushNotifications.requestPermissions().then(result => {
      console.log("requestPermissions", result);
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      (token: Token) => {
        console.log("addListener registration", token);
        console.log("addListener registration", JSON.stringify(token));
        this.registerToken(token.value);
      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.error('Error on registration: ' + JSON.stringify(error));
      }
    );

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        console.log('Push received: ' + JSON.stringify(notification));
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        console.log('Push action performed: ' + JSON.stringify(notification));
      }
    );
  }

  async registerToken(data) {
    let token = "" + data;
    console.log("registerToken", token);

    let user = await this.authService.getUser();
    console.log("user after get token :", user);
    if (user != null) {
      if (!user["devices"])
        user["devices"] = [
          {
            uuid: this.uuid,
            token: token,
          },
        ];
      else {
        let device = user["devices"].find((device) => {
          return device.uuid == this.uuid;
        });
        if (device) {
          if (device.token != token) device.token = token;
          else return;
        } else {
          user["devices"].push({
            uuid: this.uuid,
            token: token,
          });
        }
      }
      console.log("set user", JSON.stringify(user));
      await this.authService.updateUser(user.uid, user);
    }

  }
}
